module.exports = __webpack_public_path__ + "static/media/handbags_mipel_tablet.919c6405.jpg";